import { render, staticRenderFns } from "./DetailTemplate.vue?vue&type=template&id=5b5e9545&scoped=true&"
import script from "./DetailTemplate.vue?vue&type=script&lang=js&"
export * from "./DetailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5e9545",
  null
  
)

export default component.exports